import PropTypes from 'prop-types';
import React from 'react';
import styles from '../../../../../assets/styles/testCreationStyle.module.css';
import closeIcon from '../../../../../assets/images/closeSvgIcon.svg';
export default function AddBrowsingModel({ onClose, onConfirm, numOfQuestions }) {
  return (
    <div className={styles.modalOverlay}>
      <div className={styles.modalContent}>
        {/* Modal Header with Close Button */}
        <div className={styles.modalHeader}>
          <button
            onKeyDown={(e) => {
              if (e.key === 'Enter') onClose();
            }}
            className={styles.modalClose}
            onClick={onClose}
          >
            <img src={closeIcon} alt="Close" />
          </button>
        </div>

        {/* Modal Body */}
        <div className={styles.browsingModelBody}>
          <div className={styles.modalBody}>
            <p className={styles.modalBodyMainText}>Are you sure, Do you want to continue?</p>
          </div>
          {/* <p className={styles.browsingModelText}>
            This rule matches only {numOfQuestions} questions. While the system works best with 6 questions, would you like to proceed
            with the {numOfQuestions} questions currently available?
          </p> */}
          <p className={styles.browsingModelText}>
            This rule matches only fewer questions. While the system works best with 6 questions, would you like to
            proceed with the questions currently available?
          </p>
          <div className={styles.modalTwoButtons}>
            <button
              className={styles.cancelButton}
              onClick={() => {
                onClose();
              }}
            >
              Cancel
            </button>
            <div className={styles.modalButtons}>
              <button
                className={styles.confirmButton}
                onClick={() => {
                  onConfirm();
                  onClose();
                }}
              >
                Yes, Proceed
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

AddBrowsingModel.propTypes = {
  onClose: PropTypes.func,
  onConfirm: PropTypes.any,
};
